import ComponentGuard from '@/components/ui/custom/ComponentGuard';
import HackathonService from '@/components/projects/hackathon/form/HackathonService';
import { UserTypeEnum } from '@/models/User';
import { AnimatePresence, motion } from 'motion/react';
import { accordion } from '@/utils/animations/commom';
import { useQueryClient } from '@tanstack/react-query';
import { hackathonsQueryKeys } from '@/data/services/querykeys';

type AddHackathonProps = {
  show: boolean;
  setShow: (show: boolean) => void;
};

export default function AddHackathon({ show, setShow }: AddHackathonProps) {
  const queryClient = useQueryClient();
  const onSucess = async () => {
    await queryClient.invalidateQueries({
      queryKey: hackathonsQueryKeys.list._def,
    });
    setShow(false);
  };
  return (
    <ComponentGuard roles={[UserTypeEnum.SUPER_ADMIN]}>
      <div className={show ? 'overflow-visible' : 'overflow-hidden'}>
        <AnimatePresence>
          {show && (
            <motion.div className="flex justify-end" {...accordion}>
              <HackathonService
                onCancel={() => setShow(false)}
                onSucess={onSucess}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </ComponentGuard>
  );
}
